import { PartialBrief } from '../../../Types/Brief'

const CONCIERGE_COUNTRIES = ['GB', 'IE', 'US']

// briefs with emails from gmail, hotmail and yahoo do not qualify
const NON_PERSONAL_EMAIL =
  /^[a-zA-Z0-9._%+-]+@(?!(?:gmail|hotmail|yahoo)\.)(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/i

// 30k for parties
const PARTY_COLLECTION = '1'
const PARTY_MINIMUM_BUDGET = 30000

// 10k for meetings/workshops, private dining, conferences, networking
const STANDARD_COLLECTIONS = ['2', '18', '24', '26']
const STANDARD_MINIMUM_BUDGET = 10000

// A concierge lead is handled by a person, so it is also excluded from venue recommendations.
const qualifiesForConcierge = ({ country, guest, collection, budget }: PartialBrief): boolean => {
  // Every attribute here is nullable as well as optional, so guard on both.
  if (!country || !CONCIERGE_COUNTRIES.includes(country)) return false
  if (!guest?.email || !NON_PERSONAL_EMAIL.test(guest.email)) return false
  if (!collection) return false

  const amount = budget ?? 0

  if (collection === PARTY_COLLECTION) return amount >= PARTY_MINIMUM_BUDGET

  return STANDARD_COLLECTIONS.includes(collection) && amount >= STANDARD_MINIMUM_BUDGET
}

export default qualifiesForConcierge
